import React from 'react';

export interface AuthContextModel {
  doLogout?: () => void;
}

const initialContext: AuthContextModel = {};

export default React.createContext(initialContext);
